import { crud } from "../../../app/crud";
import { gSelector } from "../../../app/selector";
import { translate } from "../../../app/localisation";
import { selector } from "./selector";


const getBank = function (e) {
    let bankId = $(selector.ddlBank).val();

    let url = `/customer/prepaid-refund-request/banks/${bankId}`
    if (bankId != '') {
        $(selector.accountZr2).prop('disabled', false)
        $(selector.accountZr3).prop('disabled', false)
        $(selector.bankUniqueNumber).prop('disabled', false)
        $(selector.bankUniqueNumber).removeClass('form-select')

    }
    else {
        $(selector.accountZr2).prop('disabled', true)
        $(selector.accountZr3).prop('disabled', true)
        $(selector.bankUniqueNumber).prop('selected', false)
        $(selector.bankUniqueNumber).prop('disabled', true)
        return
    }
    crud.show(url)
        .done((response) => {
            var $select = $(selector.bankUniqueNumber);
            var uniqueNumber = response['uniqueNumbers'];
            $select.empty();

            uniqueNumber.forEach(function (value) {
                $select.append('<option value="' + value + '">' + value + '</option>');
            });

            if (uniqueNumber.length === 1) {
                $select.val([uniqueNumber[0]]);
            }

            else if (uniqueNumber.length > 1) {
                $select.val([uniqueNumber[0]]);
                $select.addClass('form-select')
                $select.prop('disabled', false);
            }
        })
        .fail((jqXHR) => {
            if (jqXHR.status == 500) {
                window.location.reload();
            }
            form.handleFailResponse($form, formFields, jqXHR)
        });

}

export { getBank };